import React, { useMemo } from 'react'
import { Outlet, useParams, useNavigate } from 'react-router-dom'
import { Stack } from '@mui/material'

import MainContent, { TableContent } from 'components-shared'
import { ResponsiveTableProvider } from 'packages/ui/Table'
import useSubscribeRefresh from 'use-subscribe-actions'

import Table from './Table'
import Filters from './Filters'
import useUsers from './use-users'
import useFiltersStore, { useContactsSelected } from '../store'
import CardInMass from './Card/CardInMass'

const ContactList = () => {
  const { sfId } = useParams()
  const apiUsers = useUsers()
  const [contactsSelected] = useContactsSelected()
  const [filters] = useFiltersStore()
  const navigate = useNavigate()
  useSubscribeRefresh(() => navigate('/contacts/list'))
  const defaultId = useMemo(() => {
    if (!sfId && apiUsers?.users.length) {
      return apiUsers.users[0].sf_id
    }
    return null
  }, [sfId, apiUsers.users])

  return (
    <Stack flex={1}>
      <Filters onChange={apiUsers.refetch} />
      <MainContent>
        <TableContent>
          <ResponsiveTableProvider>
            <Table isInternal={filters.internal} apiUsers={apiUsers} />
          </ResponsiveTableProvider>
        </TableContent>
        {contactsSelected.length > 0
          ? <CardInMass onRefetch={apiUsers.refetch} />
          : <Outlet context={{ defaultId }} />
        }
      </MainContent>
    </Stack>
  )
}

export default ContactList
